import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import { LayoutDashboard, PlusCircle, LogOut, Home } from "lucide-react";

const AdminLayout = () => {
  const { signOut, user } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-10 border-b border-white/10 bg-gradient-to-r from-[hsl(var(--navy))] to-[hsl(var(--navy))] shadow-lg">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <span className="font-bold text-white text-lg tracking-tight">Admin</span>
            <nav className="flex items-center gap-1">
              <Link to="/admin/dashboard">
                <Button variant="ghost" size="sm" className="gap-2 text-white/90 hover:text-white hover:bg-white/10">
                  <LayoutDashboard className="h-4 w-4" />
                  Dashboard
                </Button>
              </Link>
              <Link to="/admin/properties/new">
                <Button variant="ghost" size="sm" className="gap-2 text-white/90 hover:text-white hover:bg-white/10">
                  <PlusCircle className="h-4 w-4" />
                  Add property
                </Button>
              </Link>
              <a href="/" target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="sm" className="gap-2 text-white/90 hover:text-white hover:bg-white/10">
                  <Home className="h-4 w-4" />
                  View site
                </Button>
              </a>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-white/80 truncate max-w-[200px]" title={user?.email}>
              {user?.email}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="gap-2 border-white/30 bg-white/10 text-white hover:bg-red-500/90 hover:border-red-500 hover:text-white font-medium"
            >
              <LogOut className="h-4 w-4" />
              Log out
            </Button>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
